import { roundNumber } from "@common/utils/roundNumber";
import { LineChartData, LineChartDataset } from "../../types";
import {
  AggregatedStats,
  AggregatedStatsKey,
  DatasetStats,
  StatsData,
} from "./types";

const getDatasetStats = (dataset: LineChartDataset): DatasetStats => {
  const initialStats: StatsData = {
    current: 0,
    min: Number.MAX_SAFE_INTEGER,
    max: Number.MIN_SAFE_INTEGER,
    sum: 0,
    itemsWithValue: 0,
  };

  const statsData = dataset.data.reduce<StatsData>((stats, { y: value }) => {
    if (value === null) return stats;

    return {
      current: value,
      min: Math.min(stats.min, value),
      max: Math.max(stats.max, value),
      sum: stats.sum + value,
      itemsWithValue: stats.itemsWithValue + 1,
    };
  }, initialStats);

  if (statsData.itemsWithValue === 0) {
    return {
      current: "-",
      min: "-",
      max: "-",
      average: "-",
    };
  }

  return {
    current: roundNumber(statsData.current),
    min: roundNumber(statsData.min),
    max: roundNumber(statsData.max),
    average: roundNumber(statsData.sum / statsData.itemsWithValue),
  };
};

export const aggregateStatsSummary = (
  datasets: LineChartData["datasets"]
): AggregatedStats => {
  const initialStats: AggregatedStats = {
    current: [],
    average: [],
    min: [],
    max: [],
  };

  const statsSummary = datasets.map(getDatasetStats);

  return statsSummary.reduce<AggregatedStats>((aggregatedStats, statsData) => {
    for (const key in statsData) {
      const typedKey = key as AggregatedStatsKey;

      aggregatedStats[typedKey].push(statsData[typedKey]);
    }

    return aggregatedStats;
  }, initialStats);
};
